import api from "./axios";

export async function getAdminOrders(opts = {}) {
  const {
    includeWarranty = typeof opts === "boolean" ? opts : false,
    page = 1,
    pageSize = 20,
    search = "",
    startDate,
    endDate,
  } = typeof opts === "object" ? opts : { includeWarranty: opts };

  const params = { includeWarranty, page, pageSize };
  if (search) params.search = search;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  const { data } = await api.get("/orders", { params });
  return data;
}

export const patchOrderStatus = ({ orderId, status }) =>
  api.patch(`/orders/${orderId}`, { status }).then((r) => r.data);

export const createAdminOrder = (orderData) =>
  api.post("/orders", orderData).then((r) => r.data);
